module.exports = {
	"description": "MenuDividers are used to separate [MenuItems](./menu-item) and [MenuGroups](./menu-group).",
	"methods": []
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Menu/MenuDivider.js
// module id = 1626
// module chunks = 0